export const dealDetailsActivityComputed = {
  requiresEditWonHandoff() {
    const status = String(this.editForm?.status || "").trim().toLowerCase();
    return status === "won" || this.selectedEditStageType === "won";
  },
  lostReasonDialogStatusLabel() {
    const targetStatus = String(this.pendingLostReasonRequest?.targetStatus || "lost").trim().toLowerCase();
    return this.$t(`ncrm.deals.statuses.${targetStatus}`);
  },
};

export const dealDetailsActivityMethods = {
  async onDealActivityChanged() {
    await this.refreshDealActivityContext();
  },
  async refreshDealActivityTimelineIfOpen() {
    const timelineRef = this.$refs?.dealActivityTimeline;
    if (!timelineRef || typeof timelineRef.fetchActivities !== "function") return;
    try {
      await timelineRef.fetchActivities();
    } catch (error) {
      console.error("[ncrm-deal-details] refresh activity timeline error", error);
    }
  },
};
